import { passCodes } from '../passCodes';
import cipher29Image1 from '../../../../assets/images/games/zdar-escape-game/ciphers/29/image1.webp';
import cipher29Image10 from '../../../../assets/images/games/zdar-escape-game/ciphers/29/image10.webp';
import cipher29Image11 from '../../../../assets/images/games/zdar-escape-game/ciphers/29/image11.webp';
import cipher29Image12 from '../../../../assets/images/games/zdar-escape-game/ciphers/29/image12.webp';
import cipher29Image13 from '../../../../assets/images/games/zdar-escape-game/ciphers/29/image13.webp';
import cipher29Image14 from '../../../../assets/images/games/zdar-escape-game/ciphers/29/image14.webp';
import cipher29Image15 from '../../../../assets/images/games/zdar-escape-game/ciphers/29/image15.webp';
import cipher29Image16 from '../../../../assets/images/games/zdar-escape-game/ciphers/29/image16.webp';
import cipher29Image2 from '../../../../assets/images/games/zdar-escape-game/ciphers/29/image2.webp';
import cipher29Image3 from '../../../../assets/images/games/zdar-escape-game/ciphers/29/image3.webp';
import cipher29Image4 from '../../../../assets/images/games/zdar-escape-game/ciphers/29/image4.webp';
import cipher29Image5 from '../../../../assets/images/games/zdar-escape-game/ciphers/29/image5.webp';
import cipher29Image6 from '../../../../assets/images/games/zdar-escape-game/ciphers/29/image6.webp';
import cipher29Image7 from '../../../../assets/images/games/zdar-escape-game/ciphers/29/image7.webp';
import cipher29Image8 from '../../../../assets/images/games/zdar-escape-game/ciphers/29/image8.webp';
import cipher29Image9 from '../../../../assets/images/games/zdar-escape-game/ciphers/29/image9.webp';
import cipher29SnowImage1 from '../../../../assets/images/games/zdar-escape-game/ciphers/29/snowimage1.webp';
import cipher29SnowImage10 from '../../../../assets/images/games/zdar-escape-game/ciphers/29/snowimage10.webp';
import cipher29SnowImage2 from '../../../../assets/images/games/zdar-escape-game/ciphers/29/snowimage2.webp';
import cipher29SnowImage3 from '../../../../assets/images/games/zdar-escape-game/ciphers/29/snowimage3.webp';
import cipher29SnowImage4 from '../../../../assets/images/games/zdar-escape-game/ciphers/29/snowimage4.webp';
import cipher29SnowImage5 from '../../../../assets/images/games/zdar-escape-game/ciphers/29/snowimage5.webp';
import cipher29SnowImage6 from '../../../../assets/images/games/zdar-escape-game/ciphers/29/snowimage6.webp';
import cipher29SnowImage7 from '../../../../assets/images/games/zdar-escape-game/ciphers/29/snowimage7.webp';
import cipher29SnowImage8 from '../../../../assets/images/games/zdar-escape-game/ciphers/29/snowimage8.webp';
import cipher29SnowImage9 from '../../../../assets/images/games/zdar-escape-game/ciphers/29/snowimage9.webp';
import track29 from '../../../../assets/audio/tracks/track29.mp3';

const cipher29Images = [
    cipher29Image1,
    cipher29Image2,
    cipher29Image3,
    cipher29Image4,
    cipher29Image5,
    cipher29Image6,
    cipher29Image7,
    cipher29Image8,
    cipher29Image9,
    cipher29Image10,
    cipher29Image11,
    cipher29Image12,
    cipher29Image13,
    cipher29Image14,
    cipher29Image15,
    cipher29Image16,
];

const cipher29SnowImages = [
    cipher29SnowImage1,
    cipher29SnowImage2,
    cipher29SnowImage3,
    cipher29SnowImage4,
    cipher29SnowImage5,
    cipher29SnowImage6,
    cipher29SnowImage7,
    cipher29SnowImage8,
    cipher29SnowImage9,
    cipher29SnowImage10,
];

const hints = [
    {
        text: 'Zvíře se nachází přímo u nápisu "Pěší Zóna".',
    },
    {
        text: 'Dělá haf haf.',
    },
    {
        text: 'Kódem je: pes',
        solution: true,
    },
];
export const step29paths = {
    id: 27,
    title: '12. stanoviště',
    taskText: `
        <p>
            Správně! Hele, další pomoc. Vydáme se dál po fotkách. Mám pocit, že někdo asi chce, abychom na to přišli. 
        </p>
    `,
    catImage: 5,
    audio: track29,
    snowAudio: track29,
    cipher: {
        images: cipher29Images,
        isPathFinder: true,
        snowImages: cipher29SnowImages,
        snowSelectionText: `
            <p>
                Někde po cestě je na domě socha zvířete, ta nám určitě řekne víc. Je to hroznej vyzvědač a drbna. Tak se rozhlížej, ať ho nepřehlédneš. Jaké zvíře vidíte?
            </p>
        `,
    },
    codeInputText: ' ',
    codeInputPassCodeRegexp: passCodes[20],
    additionalInfo: 'Odpovědí je jedno slovo.',
    hints: hints,
    snowHints: hints,
};
